/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule, LazyloadService } from '@dm/core';

import { CifsShareService } from '../../cifs-share.service';
import { CifsShareStrService } from '../../cifs-share-str.service';
import { AddHomedirRuleCifsShareModule } from '../add-homedir-rule-cifs-share/add-homedir-rule-cifs-share.module';
import { ModifyHomedirRuleCifsShareModule } from '../modify-homedir-rule-cifs-share/modify-homedir-rule-cifs-share.module';
import { RemoveHomedirRuleCifsShareModule } from '../remove-homedir-rule-cifs-share/remove-homedir-rule-cifs-share.module';
import { FrontTableHomedirRuleCifsShareComponent } from './front-table-homedir-rule-cifs-share.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        AddHomedirRuleCifsShareModule,
        ModifyHomedirRuleCifsShareModule,
        RemoveHomedirRuleCifsShareModule,

    ],
    declarations: [FrontTableHomedirRuleCifsShareComponent],
    exports: [FrontTableHomedirRuleCifsShareComponent],
    providers: [
        LazyloadService,
        CifsShareStrService,
        CifsShareService,
    ],
})
export class FrontTableHomedirRuleCifsShareModule { }
